export default "/images/gfforsikring.avif?bca16fd97b420cd479de017df0554002";